import { NetworkService } from '../../services/NetworkService'

const mutations = {
  resetState(state: any) {
    state.financeOptions = []
    state.leaseOptions = []
    state.termType = 'Lease'
    state.term = 0
    state.financeRate = 0
    state.leaseRate = 0
  },
  updateFinanceRate(state: any, newRate: number) {
    state.financeRate = newRate
  },
  updateLeaseRate(state: any, newRate: number) {
    state.leaseRate = newRate
  },
  updateOptions(state: any, args: any) {
    state.financeOptions = args.financeOptions
    state.leaseOptions = args.leaseOptions
  },
  updateFrequency(state: any, frequency: string) {
    state.frequency = frequency
  },
  updateTermType(state: any, newType: string) {
    state.termType = newType
  },
  updateTerm(state: any, newTerm: number) {
    state.term = newTerm
  }
}

const getters = {
  financeOptions(state: any) {
    return state.financeOptions
  },
  leaseOptions(state: any) {
    return state.leaseOptions
  },
  currentFrequency(state: any) {
    return state.frequency
  },
  rate(state: any) {
    return state.termType === 'Lease' ? state.leaseRate : state.financeRate
  },
  term(state: any) {
    return state.term
  },
  termType(state: any) {
    return state.termType
  }
}

const actions = {
  async getTerms(context: any, args: any) {
    context.commit('resetState')
    const res = await NetworkService.get(
      process.env.VUE_APP_API_BASE_URL +
      '/api/v1/terms?trim=' + args.trim.id + '&model=' + args.modelId + '&manufacturer=' + args.manufacturer
    )

    context.commit('updateOptions', { financeOptions: res.data.finance, leaseOptions: res.data.lease })
    context.commit('updateLeaseRate', res.data.lease[res.data.lease.length - 1].rate)
    context.commit('updateFinanceRate', res.data.finance[res.data.finance.length - 1].rate)
    context.commit('updateTerm', res.data.lease[res.data.lease.length - 1].term)
  }
}

const state = () => ({
  frequency: 'Weekly',
  financeOptions: [] as number[],
  leaseOptions: [] as number[],
  financeRate: 0 as Number,
  leaseRate: 0 as number,
  termType: 'Lease' as string,
  term: 0 as number
})

export default {
  namespaced: true,
  mutations,
  getters,
  state,
  actions,
}
